module.exports = __webpack_public_path__ + "img/pay.1ac952c5.svg";